import html2canvas from "html2canvas";
import { useEffect, useRef, useState } from "react";
import { IoHammerOutline } from "react-icons/io5"
import styled from "styled-components";



interface IconBackgroundProps {
}

export default function IconBackground(props: IconBackgroundProps) {
  console.log("IconBackground props:", props)

  const divRef = useRef<HTMLDivElement>(null);
  const [thumb, setThumb] = useState(null);
  const [icons, setIcons] = useState([]);

  useEffect(() => {
    if (!divRef || !divRef.current) {
      return;
    }
    const makeThumb = async () => {
      const canvas = await html2canvas(divRef.current, {
        scale: 1.0, 
        useCORS: true,
        allowTaint: true,
        backgroundColor: 'orange',
        windowWidth: document.documentElement.clientWidth,
        windowHeight: document.documentElement.clientHeight,
      });   
      console.log("setThumb:", canvas);
      setThumb(canvas.toDataURL());

      if (icons.length < 20) {
        const hammer = (<IoHammerOutline key={icons.length + "_" + (Math.random() * 50)} size={18 * 5} style={{
          position: "absolute",
          width: "auto",
          height: "auto",
          background: "blue",
          top: Math.round(Math.random() * 1000),
          left: Math.round(Math.random() * 1000),
          transform: "rotate(60deg)"
        }} />)
        setIcons((prev) => [...prev, hammer]);
      }
    }
    setTimeout(() => {
      makeThumb();
    }, 500);
  }, [icons]);

  return (
    <IconDiv ref={divRef}>
      <img src='/green_thumb.jpg' style={{
        position: 'absolute',
        width: '500px',
        height: '500px'
      }} />
      {icons}
      {thumb && (
        <ThumbnailContainer>
          <ThumbnailImage src={thumb} alt="Thumbnail" />
        </ThumbnailContainer>
      )}
    </IconDiv>
  )
}

const IconDiv = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #FFFFFF;
`;

const ThumbnailContainer = styled.div`
  position: absolute;
  top: 1000px;
  left: 1000px;
  width: 1000px;
  height: 1000px;
  border: 1px solid #aaa;
  overflow: hidden;
`;

const ThumbnailImage = styled.img`
  width: 100%;
  height: auto;
`;
